import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { insertExternalScript } from '../../util/insertScript';
import { GLOBAL_SRC } from './scriptSrc';
import { getCookie } from '../../util/getCookie';
import { push as dataLayerPush, gtag as dataLayerGtag } from './../dataLayer';
import { getDomain } from '../../util/getDomain';
var DOMAIN_SCRIPT_ID = '50da44be-0564-43df-b139-329aedcf267b';
export function load(_ref) {
  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout,
      oneTrustDomainScript = _ref.oneTrustDomainScript;
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var loadTimer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            window.OptanonWrapper = handleLoad;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              insertExternalScript({
                dataset: {
                  domainScript: oneTrustDomainScript ? oneTrustDomainScript : DOMAIN_SCRIPT_ID,
                  documentLanguage: 'true'
                },
                onError: reject,
                onLoad: resolve,
                src: GLOBAL_SRC
              });
              loadTimer = setTimeout(reject, timeout);
            }).then(function () {
              return clearTimeout(loadTimer);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export function handleLoad() {
  if (!window.gtag) {
    window.gtag = dataLayerGtag;
  }

  var consentParam = getCookie('OptanonConsent').split('&').filter(function (kv) {
    return kv.split('=')[0] === 'consentId';
  })[0];

  if ((window.__cmp || window.__tcfapi) && window.OptanonActiveGroups && consentParam) {
    handleLoadSuccess(consentParam);
  }
}

function handleLoadSuccess(consentParam) {
  var consentId = consentParam.split('=')[1];

  if (window.__tcfapi) {
    window.__tcfapi('getTCData', 2, handleVendorConsentsV2(consentId));
  } else {
    window.__cmp('getVendorConsents', {}, handleVendorConsentsV1(consentId));
  }
}

function handleVendorConsentsV1(consentId) {
  return function handleConsents(data) {
    var consentData = JSON.stringify({
      id: consentId,
      iab: data.metadata,
      cate: window.OptanonActiveGroups
    });
    setConsentCookie();
    dataLayerPush({
      consentData: consentData
    });
  };
}

function handleVendorConsentsV2(consentId) {
  return function handleConsents(data, success) {
    if (!success) {
      return;
    }

    var consentData = JSON.stringify({
      id: consentId,
      iab: data.tcString,
      cate: window.OptanonActiveGroups
    });
    setConsentCookie();
    dataLayerPush({
      consentData: consentData
    });
  };
}

var CONSENT_COOKIE_NAME = 'sp_consent';
var CONSENT_COOKIE_MAX_AGE = -1000;

function setConsentCookie() {
  var domain = getDomain(window.location.hostname);
  document.cookie = ["".concat(CONSENT_COOKIE_NAME, "="), "max-age=".concat(CONSENT_COOKIE_MAX_AGE), "domain=".concat(domain), 'path=/'].join('; ');
}